import React from "react";
export default function SquareWarningMessage(_a) {
    var message = _a.message;
    return React.createElement("div", { className: "p-2 mb-4 alert-warning", style: { borderWidth: 1, borderRadius: 10 } }, message);
}
